import moment from 'moment';

class LeaveUsageModalController {
  constructor($scope, $uibModalInstance, yearStats, LeaveService, TimesheetService) {
    "ngInject";
    this.name = 'LeaveUsageModal';
    this.$uibModalInstance = $uibModalInstance;
    this.ptoService = LeaveService;
    this.timesheetsService = TimesheetService;
    this.yearStats = yearStats;
    
    // Calculate leave stats for the selected year
    if (this.ptoService.leaveTypes && this.ptoService.leaveTypes.length > 0) {
      const leaveType = this.ptoService.leaveTypes[0];
      const originalSelectedYear = leaveType.selectedLeaveYear;
      leaveType.selectedLeaveYear = yearStats.selectedYear;
      
      this.leaveStats = this.ptoService.calculateLeaveTypePtoStats(leaveType, yearStats.selectedYear);
      
      // Restore original selected year
      leaveType.selectedLeaveYear = originalSelectedYear;
    }

    this.heatMapConfig = {
      start: moment().toDate(),
      domain: "month",
      subDomain: "x_day",
      cellSize: 20,
      range: 1,
      displayLegend: false,
      subDomainTextFormat: "%d",
      legend: [2, 4, 6, 8, 10],
      weekStartOnMonday: false,
      label: {
        position: "top"
      },
      itemName: "hour"
    };
    
    // Pre-compute all config objects to prevent infinite digest loops
    this.heatMapConfigs = [];
    for (let month = 0; month < 12; month++) {
      const monthTotalHours = this.getMonthTotalHours(month);
      const monthName = this.getMonthName(month);
      
      this.heatMapConfigs[month] = Object.assign({}, this.heatMapConfig, {
        start: moment().month(month).year(this.yearStats.selectedYear).toDate(),
        customLabelText: `${monthName} (${monthTotalHours} hrs)`
      });
    }
  }

  isCurrentYear(year) {
    return parseInt(moment().year()) === parseInt(year);
  }

  getHeatMapConfig(month) {
    // Return pre-computed config to avoid creating new objects
    return this.heatMapConfigs[month] || this.heatMapConfig;
  }

  /**
   * Get total hours for a specific month
   * @param {number} monthIndex - Month index (0-11)
   * @returns {number} Total hours for the month
   */
  getMonthTotalHours(monthIndex) {
    if (!this.leaveStats || !this.leaveStats.leaveTakenByDay) {
      return 0;
    }

    const year = this.yearStats.selectedYear;
    const startOfMonth = moment().year(year).month(monthIndex).startOf('month');
    const endOfMonth = moment().year(year).month(monthIndex).endOf('month');

    let totalHours = 0;
    Object.keys(this.leaveStats.leaveTakenByDay).forEach((timestamp) => {
      const date = moment(parseInt(timestamp) * 1000);
      if (date.isSameOrAfter(startOfMonth) && date.isSameOrBefore(endOfMonth)) {
        const hours = parseFloat(this.leaveStats.leaveTakenByDay[timestamp]) || 0;
        totalHours += hours;
      }
    });

    return totalHours.toFixed(2);
  }

  /**
   * Get month name from index
   * @param {number} monthIndex - Month index (0-11)
   * @returns {string} Month name
   */
  getMonthName(monthIndex) {
    return moment().month(monthIndex).format('MMMM');
  }

  close() {
    this.$uibModalInstance.dismiss();
  }
}

export default LeaveUsageModalController;




// WEBPACK FOOTER //
// ./client/pages/leave/modals/leave-usage/leave-usage.controller.js